import script from "./LiquidityCompetitionBanner.vue?vue&type=script&setup=true&lang=ts"
export * from "./LiquidityCompetitionBanner.vue?vue&type=script&setup=true&lang=ts"

import "./LiquidityCompetitionBanner.vue?vue&type=style&index=0&id=3b8a06ae&scoped=true&lang=scss"

import exportComponent from "/home/centos/workspace/Blueshift Core/blueshift-frontend-PROD-deploy/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3b8a06ae"]])

export default __exports__